/**
 * Convert a customer-entered dollar string (e.g. "0.32") into integer cents,
 * or `undefined` if the input is empty / malformed / non-positive.
 *
 * Stripe's verifyMicrodeposits endpoint takes integer cents, so we have to
 * parse carefully — silently rounding a malformed value (e.g. "0.5.5") into
 * a real verification attempt would burn one of the customer's limited
 * Stripe retry slots.
 */
export function bankAccountsParseMicrodepositAmount(
  input: string,
): number | undefined {
  const trimmed = input.trim();
  if (!trimmed) return undefined;
  // Allow patterns like "0.32", ".32", "0.3", "1". Cap at 2 decimals; any
  // other shape (negatives, exponents, multiple dots) is rejected.
  if (!/^\d*\.?\d{0,2}$/.test(trimmed)) return undefined;
  const dollars = parseFloat(trimmed);
  if (!Number.isFinite(dollars) || dollars <= 0) return undefined;
  return Math.round(dollars * 100);
}
